import {Component} from '@angular/core';
// AG-Grid
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
	selector: 'cv-appraisal-person-status-cell',
	templateUrl: './custom-person-cell.component.html',
	styleUrls: ['./custom-person-cell.component.scss']
})
export class CustomPersonCellComponent implements ICellRendererAngularComp {
	public cellValue: any;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.value;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
